import { ReactElement, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { AuthPath } from "@routers/path/AuthPath";

import { UserInfo } from "@features/auth/slice";

const AuthGuard = ({
  children,
  userInfo,
}: {
  children: ReactNode;
  userInfo?: UserInfo | undefined;
}) => {
  const location = useLocation();

  if (userInfo) {
    return children as ReactElement;
  }
  return (
    <Navigate
      to={`${AuthPath.signIn}?redirectTo=${location.pathname}${location.search}`}
    />
  );
};

export default AuthGuard;
